var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-col',{staticClass:"copyRight"},[_c('p',[_c('a',{attrs:{"href":"www.plotnetwork.ltd"}},[_vm._v(" © 2021-2023 Plot Network Ltd,"+_vm._s(_vm.$t("cpright1"))+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }